import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { BrandLink } from "@/components/Logo";
import { ThemeToggle } from "@/components/ThemeToggle";
import { GenderStep } from "@/components/onboarding/GenderStep";
import { ProfileStep } from "@/components/onboarding/ProfileStep";
import { PoliciesStep } from "@/components/onboarding/PoliciesStep";
import { useAuth } from "@/context/AuthContext";

const Steps = ({ step }) => (
  <div className="flex flex-wrap items-center gap-2 text-xs font-semibold" data-testid="onboarding-steps">
    {["Sign in", "Profile", "About you", "Policies"].map((s, i) => (
      <div key={s} className="flex items-center gap-2">
        <span className={`h-6 w-6 rounded-full flex items-center justify-center ${i <= step ? "brand-gradient text-white" : "bg-secondary text-muted-foreground"}`}>{i + 1}</span>
        <span className={i === step ? "text-foreground" : "text-muted-foreground"}>{s}</span>
        {i < 3 && <span className="w-6 h-px bg-border" />}
      </div>
    ))}
  </div>
);

export default function Onboarding() {
  const { onboarding, setOnboarding, logout } = useAuth();
  const navigate = useNavigate();
  const step = !onboarding.profile_done ? 1 : !onboarding.gender_done ? 2 : 3;
  const done = (state) => { setOnboarding(state); if (state.complete) navigate("/app", { replace: true }); };

  return (
    <div className="min-h-screen" data-testid="onboarding-page">
      <header className="glass sticky top-0 z-40">
        <div className="max-w-3xl mx-auto px-4 h-16 flex items-center justify-between">
          <BrandLink />
          <div className="flex items-center gap-2">
            <ThemeToggle />
            <button data-testid="onboarding-logout-button" onClick={async () => { await logout(); navigate("/"); }} className="h-10 px-4 rounded-full border border-border text-sm inline-flex items-center gap-1.5"><LogOut className="h-4 w-4" />Log out</button>
          </div>
        </div>
      </header>
      <main className="max-w-2xl mx-auto px-4 py-10 space-y-8">
        <Steps step={step} />
        {step === 1 ? <ProfileStep onDone={done} /> : step === 2 ? <GenderStep onDone={done} /> : <PoliciesStep onboarding={onboarding} onDone={done} />}
      </main>
    </div>
  );
}
